import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "", innerClassName = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className={`block ${innerClassName}`}
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionHeading = ({ index, overline, title, description, dark = false, center = false }) => (
  <div className={`mb-12 sm:mb-16 ${center ? "text-center" : ""}`} data-testid={`section-heading-${overline?.toLowerCase().replace(/\s+/g, "-")}`}>
    <Reveal>
      <div className={`flex items-baseline gap-4 ${center ? "justify-center" : ""}`}>
        {index && <span className="font-cinzel text-sm text-brand-gold tracking-widest">{index}</span>}
        <p className="overline-label">{overline}</p>
      </div>
    </Reveal>
    <Reveal delay={0.1}>
      <h2 className={`mt-4 font-serif text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight leading-tight ${dark ? "text-brand-cream" : "text-brand-burgundy"}`}>
        {title}
      </h2>
    </Reveal>
    {description && (
      <Reveal delay={0.2}>
        <p className={`mt-4 max-w-xl text-base leading-relaxed ${dark ? "text-brand-cream/70" : "text-brand-ink-muted"} ${center ? "mx-auto" : ""}`}>
          {description}
        </p>
      </Reveal>
    )}
  </div>
);
